import { Component } from 'react';
import ReactDOM from 'react-dom';


/**
 * Portal.
 */
export default class Portal extends Component {
    /**
     * handler.
     */
    constructor(props) {
        super(props);
        this.el = document.createElement('div');
    }

    /**
     * Function.
     */
    componentDidMount() {
        // The portal element is inserted in the DOM tree after
        // the Modal's children are mounted, meaning that children
        // will be mounted on a detached DOM node. If a child
        // component requires to be attached to the DOM tree
        // immediately when mounted, for example to measure a
        // DOM node, or uses 'autoFocus' in a descendant, add
        // state to Modal and only render the children when Modal
        // is inserted in the DOM tree.
        document.getElementById('modalReact')?.tagName?.toLowerCase() === 'div' && document.getElementById('modalReact').appendChild(this.el);
    }

    /**
     * Function.
     */
    componentWillUnmount() {
        document.getElementById('modalReact') && document.getElementById('modalReact').removeChild(this.el);
    }


    /**
     * Function.
     */
    render() {
        return ReactDOM.createPortal(
        this.props.children,
        this.el
        );
    }
}
